/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-09-29 14:11:16
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-09 15:06:14
 */
import { ActionContext } from 'vuex'
import { IStore, IApp, ISystemSetting } from '@/store/types.d'
import { setStorageItem, getStorageItem } from '@/utils/util'
import commonApi from '@/api/common'

// import dark from '@/styles/index.dark.less'
// import light from '@/styles/index.light.less'

// const themeStyle = {
//   light,
//   dark
// }

// 添加皮肤的方法
function addSkin(content: string) {
  const head = document.getElementsByTagName('head')[0]
  const getStyle = head.querySelectorAll('style')
  // 查找style是否存在，存在的话需要删除dom
  if (getStyle.length > 0) {
    for (let i = 0, l = getStyle.length; i < l; i++) {
      const curStyle = getStyle[i]

      if (!curStyle || !curStyle.dataset) {
        continue
      }

      // 删除默认的浅色主题样式
      if (curStyle.innerHTML.includes('.theme-light-less')) {
        curStyle.remove()
      }

      // 删除默认的深色主题样式
      if (curStyle.innerHTML.includes('.theme-dark-less')) {
        curStyle.remove()
      }

      if (curStyle.dataset.type === 'theme') {
        curStyle.remove()
      }
    }
  }
  // 最后加入对应的主题和加载less的js文件
  let styleDom: HTMLElement | null = document.querySelector('.theme-style')

  if (!styleDom) {
    styleDom = document.createElement('style')
    styleDom.dataset.type = 'theme'
    styleDom.className = 'theme-style'
    styleDom.innerHTML = content
    head.appendChild(styleDom)
  }

  // 查找script是否存在
  const getScript = head.getElementsByTagName('script')
  if (getScript.length > 0) {
    for (let i = 0, l = getScript.length; i < l; i++) {
      const curScript = getScript[i]

      if (!curScript || !curScript.dataset) {
        continue
      }

      if (curScript.dataset && curScript.dataset.type === 'theme') {
        getScript[i].remove()
      }
    }
  }

  // 这个less.js一定要放到后面才行
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.dataset.type = 'theme'
  // script.src = './js/less.min.js'
  head.appendChild(script)
}

import logoImg from '@/assets/logo.png'
const sysSettingDefault = () => ({
  systemLogo: logoImg,
  systemPicture: './favicon.ico',
  systemName: '鲲云可视化监控中心',
  headLogo: './inLogo.png'
})

const state: IApp = {
  theme: getStorageItem('theme') || 'light',
  systemSetting: {
    ...sysSettingDefault()
  },
  hasInstallPlugin: false
}

const mutations = {
  SET_THEME: (state: IApp, theme: string) => {
    state.theme = theme
    setStorageItem('theme', theme)
  },
  SET_SYSTEM_SETTING_ALL: (state: IApp, settings: ISystemSetting) => {
    state.systemSetting = settings
  },
  SET_PLUGIN_INSTALL_STATUS: (state: IApp, installStatus: boolean) => {
    state.hasInstallPlugin = installStatus
  }
}

const actions = {
  async setTheme({ commit }: ActionContext<IApp, IStore>, theme: string) {
    commit('SET_THEME', theme)

    // addSkin(themeStyle[theme])
  },
  // 系统设置
  async setSystemSetting(
    { commit, state }: ActionContext<IApp, IStore>,
    opt: { key: string; value: string }
  ) {
    const settings = {
      ...state.systemSetting,
      [opt.key]: opt.value
    }
    const res = await commonApi.setSystemSetting(settings)
    if (res) {
      commit('SET_SYSTEM_SETTING_ALL', settings)
      return res
    }
  },
  // 查询系统设置
  async checkSystemSetting({ commit }: ActionContext<IApp, IStore>) {
    const res = await commonApi.getSystemSetting()
    const defConfig = sysSettingDefault()

    if (res) {
      const systemLogo = res.systemLogo || defConfig.systemLogo
      const systemPicture = res.systemPicture || defConfig.systemPicture
      const systemName = res.systemName || defConfig.systemName
      const headLogo = defConfig.systemLogo

      commit('SET_SYSTEM_SETTING_ALL', {
        systemLogo,
        systemName,
        systemPicture,
        headLogo
      })
      return res
    }
  },
  setPluginInstallStatus({ commit }: ActionContext<IApp, IStore>, installStatus: boolean) {
    commit('SET_PLUGIN_INSTALL_STATUS', installStatus)
  }
}

const app = {
  state,
  mutations,
  actions
}

export default app
